'use client';

import React from 'react';
import Image from 'next/image';
import DownloadButton from './DownloadButton';

const HeroSection: React.FC = () => {
  return (
    <section className='bg-[#F8F5FF]'>
      <div className='max-w-6xl mx-auto px-6 sm:px-8 pt-16'>
        <div className='max-w-4xl mx-auto text-center'>
          <h1 className='text-4xl sm:text-5xl md:text-6xl font-bold mb-6'>
            <div className='inline-flex items-center gap-2'>
              <Image
                src='/logo-1.png'
                alt='Takeoff Logo'
                width={60}
                height={60}
              />
              <span className='block'>Takeoff</span>
            </div>
            <span className='block text-[#6B46C1]'>
              Generate Unit Tests in Seconds
            </span>
          </h1>
          <div className='retro-card inline-block mb-8 max-w-2xl'>
            <p className='text-lg sm:text-xl font-semibold'>
              Ship with the confidence of an army of test engineers—without
              hiring one. ✨
            </p>
          </div>
          <div className='flex flex-col sm:flex-row gap-4 justify-center'>
            <DownloadButton variant="primary" source="vscode">
              Install on VS Code 🚀
            </DownloadButton>
            <DownloadButton variant="secondary" source="cursor">
              Install on Cursor 💫
            </DownloadButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
